// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/goals/KeyGoalList.scss
// module id = 1318
// module chunks = 0